<template>
    <div class="sms-code-container">
        <div class="btn-code" @click="get_code" :class="{ 'in-active': second > 0 }" >
            {{ text }}
        </div>

    
    </div>

</template>

<script>
import util from '@/utils/util'
import {
    SendEmail
} from "@/api/index.js"
export default {
    name: "SmsCode",
    props: {
        email: {
            type: String,
        },
        scene: {
            type: String,
            default: 'common'
        },
    },
    components: {
       
      
    },
    data() {
        return {
         
            interval_id: null,
            second: 0
        }
    },
    computed: {
        text() {
            if (this.second > 0) {
                return `${this.second}S ` + this.$t('login.re_end')
            }

            return this.$t('login.send_code')
        },
    },
    methods: {
        
        get_code() {
           
            if (this.second > 0) {
                return
            }
            if (!util.isEmail(this.email)) {
                this.$layer.msg(`Email fail`)
                return
            }

            SendEmail({
                email: this.email,
                scene: this.scene
            }).then(() => {
                this.second = 60
                this.interval_id = setInterval(() => {
                    if (this.second === 0) {
                        clearInterval(this.interval_id)
                    }

                    this.second--
                }, 1000)
            }).catch((res) => {
                this.$layer.msg(res.msg)
            })
        },
    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">
.sms-code-container {
   
    display: flex;
    justify-content: center;
    align-items: center;
}

.btn-code {
    font-size: 14px;
    color: #EE2E47;
    cursor: pointer;

    &.in-active {
        color: #666666;
        cursor: auto;
    }
}

::v-deep .popup-modal {
    .ppp {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        .info {
            margin: 20px 0;
            font-size: 14px;
            color: #4d4d4e;
        }

        .captcha {}

        .again {
            width: 100%;
            text-align: center;
            color: #EE2E47;
            font-size: 12px;
            margin: 15px 0;
            cursor: pointer;
        }

        input {
            display: block;
            width: 280px;
            height: 40px;
            line-height: 40px;
            border-radius: 6px;
            background: #EFEFF0;
            outline: none;
            border: none;
            padding: 10px;
        }

        .btn-confirm-code {
            width: 280px;
            height: 40px;
            line-height: 40px;
            margin: 15px 0;
            background: #EE2E47;
            border-radius: 6px;
            text-align: center;
            font-size: 16px;
            color: white;
        }
    }
}
</style>
